var ociCall = {
    // stores the open oci calls so we can close the correct one
    openCalls: {},
    windowMode: false,
    //opens the oci call tot he external shop,
    listenForClose: function (event) {
        console.log('listenForClose ...');
        if (event.key != 'closeOciTab')
            return;
        ociCall.ociCloseHandle(JSON.parse(localStorage.getItem('closeOciTab')));
    },
    ociCloseHandle: function (ociTab) {
        this.setErrors(ociTab);
        this.closeOciCall(ociTab);
        this.submitForm(ociTab);
    },
    ociOpen: function (popup) {
        ociCall.openCalls[popup.name] = popup;
        if (typeof configs != 'undefined' && configs.settings && configs.settings.ociCallBackendAddCheck) {
            console.log('ociOpen set intervalID');
            intervalID = setInterval(ociCall.ociCallBackendValidate, 3000);
        }
        window.addEventListener('storage', ociCall.listenForClose, false);
    },
    ociCallBackendValidate: function () {
        console.log('ociCallBackendValidate ...');
        AjaxHandlerByClass(
            'ajax/ArticleSearch/ActiveCart/ociArticleWatch', {},
            function (data) {
                if (data.articleAdded) {
                    document.dispmenu.displaymenu.value = 'cart';
                    document.dispmenu.submit();
                }
            },
            function (data) {
                notification.warning('Got an error from backendCall assuming success in handling the oci catalog!! going to cart in 10 seconds!!!');
                setTimeout(function () {
                    document.dispmenu.displaymenu.value = 'cart';
                    document.dispmenu.submit();
                }, 10000);
            })
    },
    submitForm: function (ociTab) {
        if (typeof (DigSearch) !== 'undefined') {// the dig search is active.
            return window.parent.DigSearch.getApplication().getController('Search').ociCloseHandle(ociTab.dataSummary);
        }

        if (ociTab.submitForm) {
            if (ociTab.clearTarget) {
                document[ociTab.submitForm].target = '';
            }
            document[ociTab.submitForm].submit();
        }
    },
    closeOciCall: function (ociTab) {
        if (!this.openCalls[ociTab.tabName]) return;
        ociCall.openCalls[ociTab.tabName].close();
    },

    setErrors: function (ociTab) {
        if (ociTab.data)
            $.each(ociTab.data, function (index, value) {
                if (document.dispmenu[index]) {
                    document.dispmenu[index].value = value;
                }
            });
    },


    ret: {data: {}},
    //sends the close post message to the original tab, does not rely on opener. Sends the error data to.
    callCloseOci: function () {
        console.log('callCloseOci ...');
        debugger;
        this.ret.tabName = window.name;
        this.ret.submitForm = 'dispmenu';

        this.addInfoMessage('- Sending backend data to close this window...');
        localStorage.setItem("closeOciTab", JSON.stringify(this.ret));

        setTimeout(function () {
            ociCall.addInfoMessage('- Trying to go to Cart on older browsers...');
            ociCall.legacyClose();
            ociCall.backupClose();
        }, 2000);
    },
    //Closes the oci after some time regardles of the original tab.
    backupClose: function () {
        console.log('closing automatically after 3 seconds...');
        if (this.windowMode) {
            this.addInfoMessage('Redirecting this window back to your cart now!');
            // this.addInfoMessage('If you are seeing this message in a separate tab,or inside our search panel, please contact our support, because this catalogue is misconfigured!!!');
            setTimeout(function () {
                document.dispmenu.submit();
            }, 3000);
        } else {
            // show the message so it is shown if a prompt for closing is activated.
            this.addInfoMessage("<color='red'>Your Browser security policy is configured to prevent this tab from closing. Please close this tab manually.</color>");
            if (window.top) { // prevent double clicking the close button in IE
                window.top.close();
            } else {
                window.close();
            }
        }

    },
    legacyClose: function () {
        console.log('legacyClose ...');
        var myopener = this.getOpener();
        if (opener || window.opener || self.opener) {
            console.log('legacyClose opener ...');
            if (myopener.document && myopener.document.dispmenu) {
                $.each(this.ret.data, function (index, value) {
                    // if (value && tabName && (value == tabName)) return;
                    if (myopener.document.dispmenu[index]) {
                        myopener.document.dispmenu[index].value = value;
                    }
                });
                myopener.document.dispmenu.target = "";
                myopener.document.dispmenu.displaymenu.value = 'cart';
                myopener.document.dispmenu.submit();
            }
        } else {
            this.addInfoMessage('- Failed to go to cart on older browsers!');
        }
        if (document.dispmenu)// if the code is running not inside a tab but inside a window.
            $.each(this.ret.data, function (index, value) {
                // if (value && tabName && (value == tabName)) return;
                if (document.dispmenu[index]) {
                    document.dispmenu[index].value = value;
                }
            });
    },
    getOpener: function () {
        if (opener) {
            var myopener = opener;
            this.addInfoMessage('- This window is working with an opener function');
        } else if (window.opener) {
            var myopener = window.opener;
            this.addInfoMessage('- This window is working with an window.opener function');
        } else if (self.opener) {
            this.addInfoMessage('- This window is working with an self.opener function');
            var myopener = self.opener;
        }
        return myopener;
    },
    addInfoMessage: function (message) {
        if (document.getElementById('ociFrameErrorMsg'))
            document.getElementById('ociFrameErrorMsg').innerHTML += "<br>" + message;
    }
}


/*******************************/
/****** window.open calls ******/
// Firefox-Problem, öffnen von window + tab
// Ticket: https://helpdesk.dig.at/otrs/index.pl?Action=AgentTicketZoom;TicketID=107250
// Stack:  https://stackoverflow.com/questions/76332896/firefox-form-submitting-into-newly-created-window?noredirect=1#comment134605337_76332896
/*******************************/

/* the form ocicall must exist */
function openOciCall(catalogpartner, searchString) {
    openOciCallResize(catalogpartner, searchString, 800, 600)
}

function openOciCallResize(catalogpartner, searchString, width, height) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.search_string.value = searchString;
    var target = document.ocicall.target;
    document.ocicall.target = '';
    document.ociCallName = 'ociCallWindow' + Math.random().toString(36).substring(7);

    var popup;

    console.log("window.open");

    if (width < 9999) {
        popup = window.open('ocicall.phtml', document.ociCallName, 'width=' + width + ',height=' + height + ',resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    } else {
        popup = window.open('ocicall.phtml', document.ociCallName);
    }


    if (!popup || popup.closed || typeof popup.closed == 'undefined')
        return notification.error('Your browser is blocking the popups for this site. Please enable popups first');

    popup.onload = function () {
        popup.document.write(document.ocicall.outerHTML);
        popup.document.ocicall.submit();
    }

    //console.debug(document.ocicall.outerHTML);

    popup.document.write(document.ocicall.outerHTML);
    popup.document.ocicall.submit();
    document.ocicall.target = target;


    ociCall.ociOpen(popup);

    return false;
}

function openOciCallDetail(productid, catalogpartner, mercateoOciDetail) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.productid.value = productid;
    document.ocicall.mercateoOciDetail.value = mercateoOciDetail;
    document.ocicall.ocifunction.value = 'DETAIL';

    let size = 'width=800,height=600';
    if (mercateoOciDetail) {
        size = 'width=1200,height=768';
    }

    if(!isFirefox()){
        var popup = window.open('#', 'ociCallWindow', ',resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        ociCall.ociOpen(popup);
    }

    //oci.document.ocicall.target = '';
    document.ocicall.submit();
    return false;
}

function openOciCallDetailResize(productid, catalogpartner, width, height) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.productid.value = productid;
    document.ocicall.ocifunction.value = 'DETAIL';

    if(!isFirefox()){
        var popup = window.open('#', 'ociCallWindow', 'width=' + width + ',height=' + height + ',resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        ociCall.ociOpen(popup);
    }

    //oci.document.ocicall.targe t = '';
    document.ocicall.submit();
    return false;
}

function openOciCallDetailIFrame(productid, catalogpartner, width, height, sellername) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.productid.value = productid;
    document.ocicall.ocifunction.value = 'DETAIL';

    if (Ext.getCmp('ocItabView').items.length == 1) {
        DigSearch.getApplication().getController('Search').toggleOciCatalogs(true);
    }

    var exist = Ext.getCmp('ocItabView').getComponent('ociTab_' + catalogpartner)
    if (exist) {
        Ext.getCmp('ocItabView').setActiveTab(exist);
        return;
    }
    var base = DIG.util.Coding.objectClone(Ext.getCmp('ocItabView').defaults);
    var post = '&catalogpartnerid=' + catalogpartner;
    post += '&productid=' + productid;
    post += '&ocifunction=DETAIL';
    base.items[0].autoEl.src += post;
    base.items[0].id = 'iFrame_ociTab_' + catalogpartner;
    base.itemId = 'ociTab_' + catalogpartner;
    base.title = sellername + " OCI";
    var baseParams = {
        catId: catalogpartner,
        ociwidth: width,
        ociheight: height,
        ociInpage: 1,
        name: sellername + " OCI",
        productid: productid,
        ocifunction: "DETAIL"
    };
    base.setupData = baseParams;
    Ext.getCmp('ocItabView').add(base);
    Ext.getCmp('ocItabView').setActiveTab(base.itemId)

    if (Ext.getCmp('ocItabView').items.length == 1) {
        DigSearch.getApplication().getController('Search').toggleOciCatalogs(true);
    }
    window.addEventListener('storage', ociCall.listenForClose, false);
    return false;
}

function openOciCallArticle(articleid, catalogpartner) {
    document.ocicall.sid.value = sid;
    document.ocicall.articleid.value = articleid;
    document.ocicall.catalogpartnerid.value = catalogpartner;
    var popup = window.open('#', 'ociCallWindow', 'width=800,height=600,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    ociCall.ociOpen(popup);
    //oci.document.ocicall.target = '';
    document.ocicall.submit();
    return false;
}

function openOciCallArticleResize(articleid, catalogpartner, width, height) {
    document.ocicall.sid.value = sid;
    document.ocicall.articleid.value = articleid;
    document.ocicall.catalogpartnerid.value = catalogpartner;
    var popup = window.open('#', 'ociCallWindow', 'width=' + width + ',height=' + height + ',resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    ociCall.ociOpen(popup);
    //oci.document.ocicall.target = '';
    document.ocicall.submit();
    return false;
}

function openOciValidateDetail(productid, catalogpartner, quantity) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.productid.value = productid;
    document.ocicall.ocifunction.value = 'VALIDATE';
    document.ocicall.quantity.value = quantity;
    var popup = window.open('#', 'ociCallWindow', 'width=800,height=600,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    ociCall.ociOpen(popup);
    document.ocicall.submit();
    return false;
}

function openOciValidateDetailResize(productid, catalogpartner, quantity, width, height) {
    document.ocicall.catalogpartnerid.value = catalogpartner;
    document.ocicall.productid.value = productid;
    document.ocicall.ocifunction.value = 'VALIDATE';
    document.ocicall.quantity.value = quantity;
    var popup = window.open('#', 'ociCallWindow', 'width=' + width + ',height=' + height + ',resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    ociCall.ociOpen(popup);
    document.ocicall.submit();
    return false;
}

function openSpeedPunchoutCall() {
    window.open('#', 'speed_punchout', 'width=1600,height=800,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    document.speed_punchout.submit();
    return false;
}

function OciAddToCart(articleId, supplierAid, catalogPartner) {

    this.url = 'ajax/ArticleSearch/SearchEngine/Validate';
    this.addedToCart = function () {
        enablePageOnReload();
        classicErrrorMessage(output['t_artikel_wurden_zu_ihrem_warenkorb_hinzugefuegt']);
    };
    this.outputError = function () {
        classicErrrorMessage(output['t_artikel_kann_nicht_in_den_warenkorb_gelegt_werden'] + " (oci)");
    }
    this.data = {articles: [{}]};
    this.data.articles[0].quantity = $("input[name='articleorderamount" + articleId + "']").val();
    if (!this.data.articles[0].quantity) {
        this.data.articles[0].quantity = 1;
    }
    this.data.articles[0].catalogpartnerId = catalogPartner;
    this.data.articles[0].productId = supplierAid;


    disablePageOnReload(output['t_artikel_wird_in_warenkorb_uebernommen']);
    replaceOnLoadGIF();

    AjaxHandlerByClass(this.url, this.data, this.addedToCart, this.outputError);
}

function gotoOCICheckOut(encoding_charset) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'ocicheckout';
    document.cartform.ocicheckout_encoding.value = encoding_charset;
    document.cartform.displaymenu.value = 'none';
    submitFormGreyOut(document.cartform);
}

function isFirefox(){
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}
